<template>
  <div class="main-wrapper" style="align-items: center;
  color: #1f1f1f;
  display: flex;
  background: #fff;">
      <div style="display: none" class="error-box">
          <h1><i class="fas fa-wifi"></i></h1>
          <h3 class="h2"><i class="fas fa-exclamation-triangle"></i> Offline</h3>
          <p class="h5 font-weight-normal mt-4">We are experienced when communicating with backend system</p>
          <a href="javascript:void(0);" class="btn btn-primary" @click="healthCheck()">Retry</a>
      </div>
  </div>
</template>
<script>
import healthService from "../service/health.service";

export default {
      methods: {
        healthCheck(){
          healthService.healthCheck(localStorage.getItem("mid"))
            .then(response => {
              if (response && response.data.success){
                console.log('Redirecting to root offline error...')
                this.$router.push('/')
              } else {
                Swal.fire({
                  icon: 'warning',
                  title: 'Offline',
                  text: "We couldn't connect to backend system",
                  allowOutsideClick: false,
                  confirmButtonText: 'Retry',
                  allowEscapeKey: false,
                  footer: '<a href="">Why do I have this issue?</a>'
                }).then(result => {
                  if (result.isConfirmed){
                    this.healthCheck()
                  }
                })
              }
            })
            .catch(e => {
              console.log('Error: ', e);
              if (e.code === "ERR_NETWORK"){
                Swal.fire({
                  icon: 'error',
                  title: 'Offline',
                  text: "We couldn't connect to backend system",
                  footer: '<a href="">Why do I have this issue?</a>'
                })
              }
              if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409){
                return
              }
              this.fireNotification('error', "Oh no!", "Something went wrong!")
            });
        }
      },

        mounted() {
// Select 2
  this.healthCheck()
	if ($('.select').length > 0) {
		$('.select').select2({
			minimumResultsForSearch: -1,
			width: '100%'
		});
	}

	$(document).on('click', '#filter_search', function() {
		$('#filter_inputs').slideToggle("slow");
	});
  // Datetimepicker

	if($('.datetimepicker').length > 0 ){
		$('.datetimepicker').datetimepicker({
			format: 'DD-MM-YYYY',
			icons: {
				up: "fas fa-angle-up",
				down: "fas fa-angle-down",
				next: 'fas fa-angle-right',
				previous: 'fas fa-angle-left'
			}
		});
	}

	// Tooltip

	if($('[data-toggle="tooltip"]').length > 0 ){
		$('[data-toggle="tooltip"]').tooltip();
	}

	// Datatable

    if ($('.datatable').length > 0) {
        $('.datatable').DataTable({
            "bFilter": false,
        });
    }

    // Owl Carousel

    if ($('.images-carousel').length > 0) {
		$('.images-carousel').owlCarousel({
			loop: true,
			center: true,
			margin: 10,
			responsiveClass: true,
			responsive: {
				0: {
					items: 1
				},
				600: {
					items: 1
				},
				1000: {
					items: 1,
					loop: false,
					margin: 20
				}
			}
		});
    }

},
    }
</script>



// WEBPACK FOOTER //
// src/components/OfflineError.vue